<div class="text-area" [ngClass]="size">
  <input type="text" [mask]="getMask()" class="input-text" [ngClass]="size" [value]="value" [placeholder]="placeholder" (keyup)="_change()"
    [formControl]="control">
  <img *ngIf="searchField" src="assets/icons/Icon ionic-ios-search.svg">
  <app-square-button *ngIf="addButton" [ngClass]="control.enabled ? 'add-button' : 'add-button add-button-disabled'"
    (newActionStarted)="onAddClick()" [disabled]="control.disabled"></app-square-button>
</div>